var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.group && _vm.group._id)?_c('v-btn',{staticClass:"text-capitalize",attrs:{"outlined":"","small":"","color":"error","loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.handleRemove()}}},[_vm._v("Remove"),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("mdi-delete")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }